export default __webpack_public_path__ + "static/recent-work-2-889db5dd35772c664531ac3dfd5e4d69.png";